import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import { useIntl } from 'react-intl';
import FileSaver from 'file-saver';
import { FaSpinner, FaFileWord, FaFilePdf } from 'react-icons/fa';
import api from '@/shared/api';
import config from '@/config';
import Button from '@/shared/components/Button';
import ToastrService from '@/shared/services/ToastrService';
import adminpulse from '@/shared/utils/adminpulse';
import messages from '../messages';
/**
 * Exports the filtered/selected registrations using a chosen document template, as Word
 * or PDF. Mirrors the legacy `createRegistrationInvoiceDetailReport` dialog.
 */
const RegistrationInvoiceDetailReportModal = ({ show, relation, filters, batchParams, onClose, }) => {
    const intl = useIntl();
    const [templates, setTemplates] = useState([]);
    const [templateId, setTemplateId] = useState('');
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        api.base
            .get(`${config.appUrls.api}/api/DocumentTemplate/Templates`, {
            params: {
                templateType: 1,
                language: relation === null || relation === void 0 ? void 0 : relation.languageCode,
                relationType: relation === null || relation === void 0 ? void 0 : relation.type,
                companyId: relation === null || relation === void 0 ? void 0 : relation.companyId,
            },
        })
            .then(({ data }) => setTemplates(data || []))
            .catch(error => ToastrService.error(error));
    }, [relation]);
    const save = (asPdf) => {
        if (saving || !templateId)
            return;
        setSaving(true);
        api.base
            .post(`${config.appUrls.api}/api/Registration/DetailReport`, batchParams, {
            params: Object.assign(Object.assign({}, filters), { templateId, pdf: asPdf }),
            responseType: 'arraybuffer',
        })
            .then(result => {
            const filename = adminpulse.getFileNameFromHeader(result.headers['content-disposition']);
            const blob = new Blob([result.data], {
                type: String(result.headers['content-type'] || ''),
            });
            FileSaver.saveAs(blob, filename);
            setSaving(false);
            onClose();
        })
            .catch(error => {
            setSaving(false);
            try {
                ToastrService.error(adminpulse.arrayBufferToObject((error === null || error === void 0 ? void 0 : error.data) || error) || {});
            }
            catch (_a) {
                ToastrService.error(error);
            }
        });
    };
    return (_jsxs(Modal, Object.assign({ show: show, onHide: onClose, bsSize: "large" }, { children: [_jsx(Modal.Header, Object.assign({ closeButton: true }, { children: _jsx(Modal.Title, { children: intl.formatMessage(messages.ExportRegistrationsWithDetailTemplate) }) })), _jsx(Modal.Body, { children: _jsx("div", Object.assign({ className: "form-horizontal", role: "form" }, { children: _jsxs("div", Object.assign({ className: "form-group" }, { children: [_jsx("label", Object.assign({ htmlFor: "template", className: "col-sm-4 control-label" }, { children: intl.formatMessage(messages.Template) })), _jsx("div", Object.assign({ className: "col-sm-8" }, { children: _jsxs("select", Object.assign({ id: "template", className: "form-control", value: templateId, onChange: e => setTemplateId(e.target.value) }, { children: [_jsxs("option", Object.assign({ value: "" }, { children: ["- ", intl.formatMessage(messages.Choose), " -"] })), templates.map(t => (_jsx("option", Object.assign({ value: t.id }, { children: t.name }), t.id)))] })) }))] })) })) }), _jsxs(Modal.Footer, { children: [_jsx(Button, Object.assign({ btnClassName: "btn-default", onClick: onClose }, { children: intl.formatMessage(messages.Cancel) })), _jsxs(Button, Object.assign({ btnClassName: "btn-inverse", disabled: saving || !templateId, onClick: () => save(false) }, { children: [saving ? (_jsx(FaSpinner, { className: "fa-spin margin5R" })) : (_jsx(FaFileWord, { className: "margin5R" })), intl.formatMessage(messages.GenerateAsWord)] })), _jsxs(Button, Object.assign({ btnClassName: "btn-inverse", disabled: saving || !templateId, onClick: () => save(true) }, { children: [saving ? _jsx(FaSpinner, { className: "fa-spin margin5R" }) : _jsx(FaFilePdf, { className: "margin5R" }), intl.formatMessage(messages.GenerateAsPdf)] }))] })] })));
};
export default RegistrationInvoiceDetailReportModal;
